(function(konto) {
	konto.sp = {};
} (konto = window.konto));
